import { NFIdentity, TagCategory } from '@nibras/core/common';
import { dcTag } from './dcTag.model';

export interface NibrasTreeFlatNode<T extends NibrasTreeNode = NibrasTreeNode> {
  uniqueId: number;
  item: T;
  hasChildren: boolean;
  name: string;
  level: number;
  hideBefore: boolean;
  hideAfter: boolean;
  cssClass: string;
  toolTipText: string;
  icons: treeIcon[];
  nodeIcon: nodeIcon;
  disabled: boolean;
  isLoading?: boolean;
}

export class dcNavigationTreeGeneric<T> {
  public ID?: number;
  public Name: string;
  public Type?: NFIdentity;
  public ParentID?: number;
  public CategoryID?: number;
  public Level?: number;
  public ElementTemplateVersionID?: number;
  public TotalCount?: number;
  public value?: string;
  public children?: T[] = [];
  public hasLoaded?: boolean;
  public IsEnabled?: boolean;
  public TagID?: number;
  public Elementpath?: string;
}

export class dcNavigationTree extends dcNavigationTreeGeneric<dcNavigationTree> {}

export class NavigationTreeSearch {
  public SupportedType: NFIdentity;
  public SelectedElementVersionID: number;
  public SelectedElementCategoryID: TagCategory;
  public TemplateTags: dcTag[];
  public FilterTag: dcTag;
  public IsRoot: boolean;
  public FetchAll: boolean;
}

export interface NibrasTreeNode extends dcNavigationTree {
  children?: NibrasTreeNode[];
  tooltipText?: string;
  hideBefore?: boolean;
  hideAfter?: boolean;
  cssClass?: string;
  icons?: treeIcon[];
  nodeIcon?: nodeIcon;
}

export interface treeIcon {
  name: string;
  info: string;
}

export interface nodeIcon {
  name: string;
  color: string;
}

export interface NibrasDropDownOption<T> {
  label: string;
  value: T;
  icon?: nodeIcon;
  selected?: boolean;
}
